module.exports = __webpack_public_path__ + "static/media/icon-bulk_data.ea4012b5.svg";